declare const createjs: any;

if (!(globalThis as any).cjs) {
  (globalThis as any).cjs = createjs;

  const _createjs_Text = createjs.Text;

  const textPrototype = ((createjs.Text = function (text, font, color) {
    this._createjs_Text(text, font, color);
    //this.font = this.font.replace("*","");
    this.font = this.font.replace('Arial', 'Tahoma');
    //this.font = this.font.replace("Times New Roman","Times New Roman, Times, serif");
    //this.font = this.font.replace("Timbrel","Timbrel, Times New Roman, Times, serif");
    //this.font = this.font.replace("Suntex","Suntex, Timbrel, Times New Roman, Times, serif");
  }).prototype = _createjs_Text.prototype);

  // Overloaded functions
  textPrototype._createjs_Text = _createjs_Text;
  /*p._createjs_Text_draw = p.draw;

p.draw = function(ctx, ignoreCache) {
	return this.Text_draw(ctx, ignoreCache);	
}*/
  textPrototype._drawTextLine = function (ctx, text, y) {
    // Chrome 17 will fail to draw the text if the last param is included but null, so we feed it a large value instead:
    const xOffset = 2; //UIUtil.inUserAgent("Firefox") ? 2 : 1;
    const yOffset = 7; //UIUtil.inUserAgent("Firefox") ? 8 : 1;
    if (this.outline) {
      ctx.strokeText(text, xOffset, y + yOffset, this.maxWidth || 0xffff);
    } else {
      ctx.fillText(text, xOffset, y + yOffset, this.maxWidth || 0xffff);
    }
  };

  // New properties and functions

  textPrototype._htmlText = null;

  textPrototype.setHtmlText = function (text, fontSize) {
    if (this._htmlText == null) this._createHtmlText();
    if (fontSize) this._htmlText.style.fontSize = fontSize + 'px';
    this._htmlText.innerHTML = text;
  };
  textPrototype.hideHtmlOverlay = function () {
    this._htmlText.hidden = true;
  };
  textPrototype.showHtmlOverlay = function () {
    this._htmlText.hidden = false;
  };
  textPrototype._createHtmlText = function () {
    this._htmlText = document.createElement('div');
    const style = this._htmlText.style;

    const globalPoint = this.localToGlobal(0, 0);
    style.position = 'absolute';
    style.left = globalPoint.x + 'px';
    style.top = globalPoint.y + 'px';
    style.color = this.color;
    style.width = this.lineWidth + 'px';
    style.lineHeight = this.lineHeight + 'px';
    style.verticalAlign = 'top';
    style.textAlign = this.textAlign;
    if (this.textAlign == 'center') {
      style.left = globalPoint.x - this.lineWidth / 2 + 'px';
    } else if (this.textAlign == 'right') {
      style.left = globalPoint.x - this.lineWidth + 'px';
    }

    style.font = this.font;
    /*
	var fontBreak = this.font.indexOf(" ");
	style.fontSize = this.font.substring(0, fontBreak);
	style.fontFamily = this.font.substring(fontBreak+1, this.font.length);
	TestUtil.log(this.font, fontBreak);
	TestUtil.log(this.font.substring(0, fontBreak), this.font.substring(fontBreak+1, this.font.length));
	TestUtil.log(style.fontSize, style.fontFamily);
	*/

    document
      .getElementsByTagName('canvas')
      .item(0)!
      .parentNode!.appendChild(this._htmlText);
  };
}
